import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=65119f38&scoped=true"
import script from "./ShopItem.vue?vue&type=script&lang=js"
export * from "./ShopItem.vue?vue&type=script&lang=js"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=65119f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65119f38",
  null
  
)

export default component.exports